import React from "react";
import { FormattedMessage } from "react-intl";
import { ErrorAlert } from "theme/components/molecules/Alert";
import MiniCartTitle from "./MiniCartTitle";

const MiniCartContentError = ({ toggleMiniCart }) => {
  return (
    <div className="mini-cart-content">
      <div className="container">
        <div className="mini-cart-content__inner">
          <MiniCartTitle toggleMiniCart={toggleMiniCart} />
          <div className="mini-cart-content__main">
            <ErrorAlert position="static">
              <FormattedMessage
                id="modules.Cart.MiniCart.MiniCartContent.error"
                defaultMessage="We couldn't reach your cart. Please try again and if the problem persists contact us."
              />
            </ErrorAlert>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MiniCartContentError;
